import { ConfigurationManager } from "../utils/configurationManager";
export class widgetConsole {
    constructor(widget) {
        this.activate = () => {
            if (this.widget.configuration.debugMode) {
                $('#cbot-console').show();
                $('.cbot-console__content').addClass('expanded');
            }
        };
        this.initializeHandlers = () => {
            // ALT-SHIFT-D
            $(window).keydown((e) => {
                if (e.keyCode == 68 && e.altKey && e.shiftKey) {
                    this.activate();
                }
            });
            $('.cbot-console__minimize').click(() => {
                if ($('.cbot-console__content').hasClass('expanded')) {
                    $('.cbot-console__content').removeClass('expanded');
                }
                else {
                    $('.cbot-console__content').addClass('expanded');
                }
            });
            $('.cbot-console .cbot-console__close').click(() => {
                $('#cbot-console').hide();
            });
            $('#cbot-console-restart-chat-button').click(() => {
                this.restartChat();
            });
            $('#cbot-console-reset-login-button').click(() => {
                window.open("http://asmp.a1.net/asmp/logout?reloginDisableAutologin=" + window.location.href, "_self");
            });
            $('.cbot-console__content .textbox-copy').click((event) => {
                let element = $(event.target).prev('input');
                if (element.size() == 0)
                    element = $(event.target).parent().prev('input');
                element.select();
                document.execCommand('copy');
                window.getSelection().removeAllRanges();
            });
            $('.cbot-debugInfo .cbot-console__close').click(() => {
                $('#cbot-debugInfo').hide();
            });
            $('#cbot-console__env-form').change(() => {
                $('#cbot-console-env-input').val($('input[type=radio]:checked', '#cbot-console__env-form').val());
            });
        };
        this.restartChat = () => {
            let environment = $('#cbot-console-env-input').val();
            let openingHours = $('input[type=radio]:checked', '#cbot-console__oh-form').val();
            let userData = {};
            userData['bot_settings_key'] = $('#cbot-console-settings-key').val();
            userData['bot_settings_environment'] = environment;
            userData['bot_settings_opening_hours'] = openingHours;
            //userData['channelEntry'] = $('#cbot-console-settings-channelEntry').val();
            this.widget.addDefaultUserData(userData);
            this.widget.resetChatSession(false).then(() => {
                /*
                this.widget.setActiveContext(this.debugContext).then(() => {
                    this.widget.open({login: false});
                })
                */
                Bridge2.getMessageBus().async('InteractionContext.startContext', this.debugContext.context.context_brand + ";" + this.debugContext.context.context_detail + ";" +
                    this.debugContext.context.context_category + ";" + this.debugContext.context.context_demand + ";" + this.debugContext.context.context_sphere, { action: "chat", login: false, custom: { channelEntry: $('#cbot-console-settings-channelEntry').val() } });
            });
        };
        this.widget = widget;
        this.initializeHandlers();
        this.debugContext = ConfigurationManager.getValueIfExists(widget.configuration, "debugContext");
        if (!this.debugContext) {
            this.debugContext = { context: { context_brand: "A1", context_detail: "Privat", context_category: "Allgemein", context_demand: "Allgemein", context_sphere: "" } };
        }
        this.debugChannelEntry = ConfigurationManager.getValueIfExists(widget.configuration, "debugChannelEntry");
        if (!this.debugChannelEntry) {
            this.debugChannelEntry = "Web_Default_Sticky";
        }
        $('#cbot-console-settings-channelEntry').val(this.debugChannelEntry);
    }
    addDebugInfoButtonHandler() {
        $('#chatWindow_content').on('click', '.jsClickDebugInfo', $.proxy(function (e) {
            let debugInfo = e.currentTarget.dataset.debuginfo;
            debugInfo = decodeURI(debugInfo);
            $('#cbot-debugInfo-textarea').val(debugInfo);
            $('#cbot-debugInfo').show();
        }, this));
    }
    fillData(sessionId, userId, conversationId, instanceId) {
        $('#cbot-console-sessionId').val(sessionId);
        $('#cbot-console-userId').val(userId);
        $('#cbot-console-conversationId').val(conversationId);
        $('#cbot-console-instanceId').val(instanceId);
    }
}
